/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChipComponent} from './chip.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [ChipComponent],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [
        ChipComponent
    ]
})
export class ChipModule {
}
